/**
 * Simplified timestamp field names for aggregate POST requests.
 * Uses recursive traversal to automatically handle all nesting levels.
 * Replaces 80+ JMESPath expressions with 5 simple field names.
 */
export const AGRAPH_AGGREGATE_POST_TIMESTAMP_FIELDS = [
  'createTime',
  'updateTime',
  'asOf',
  'creationTimestamp',
  'lastUpdatedTimestamp',
];

/**
 * Simplified enum prefix configurations for aggregate POST requests.
 * Uses recursive field patterns to automatically handle all nesting levels.
 * Replaces 80+ JMESPath expressions with 5 simple field name configs.
 */
export const AGRAPH_AGGREGATE_POST_ENUM_FIELDS = [
  {
    fieldNames: ['valueType'],
    prefix: 'VALUE_TYPE_',
    recursiveFieldPatterns: [
      'mandateRestrictions',
      'benchmarkPortfolio',
      'modelPortfolio',
      'otherBenchmarks',
      'benchmark',
      'otherModels',
      'model',
      'resourceValues',
      'portfolios',
      'childAggregateValues',
    ],
  },
  {
    fieldNames: ['origin'],
    prefix: 'ORIGIN_',
    recursiveFieldPatterns: [
      'benchmarkPortfolio',
      'modelPortfolio',
      'otherBenchmarks',
      'benchmark',
      'otherModels',
      'model',
      'resourceValues',
      'portfolios',
      'childAggregateValues',
      'benchmarkRef',
      'modelRef',
      'benchRef',
      'supplement',
      'sleeveInfo',
      'modelRefs',
      'resourceEntities',
      'portfolioEntityRefs',
      'childAggregateEntities',
    ],
  },
  {
    fieldNames: ['application'],
    prefix: 'APPLICATION_',
    recursiveFieldPatterns: [
      'mandateRestrictions',
      'benchmarkPortfolio',
      'modelPortfolio',
      'otherBenchmarks',
      'benchmark',
      'otherModels',
      'model',
      'resourceValues',
      'portfolios',
      'childAggregateValues',
    ],
  },
  {
    fieldNames: ['type'],
    prefix: 'RESTRICTION_TYPE_',
    recursiveFieldPatterns: [
      'mandateRestrictions',
      'benchmarkPortfolio',
      'modelPortfolio',
      'otherBenchmarks',
      'benchmark',
      'otherModels',
      'model',
      'resourceValues',
      'portfolios',
      'childAggregateValues',
    ],
  },
  {
    fieldNames: ['severity'],
    prefix: 'SEVERITY_',
    recursiveFieldPatterns: [
      'mandateRestrictions',
      'benchmarkPortfolio',
      'modelPortfolio',
      'otherBenchmarks',
      'benchmark',
      'otherModels',
      'model',
      'resourceValues',
      'portfolios',
      'childAggregateValues',
    ],
  },
];

/**
 * Simplified enum prefix configurations for search requests.
 * Uses recursive field patterns to automatically handle all nesting levels.
 * Replaces 13 JMESPath expressions with 5 simple field name configs.
 */
export const AGRAPH_SEARCH_REQUEST_ENUM_PREFIXES = [
  {
    fieldNames: ['operationType'],
    prefix: 'OPERATION_TYPE_',
    recursiveFieldPatterns: ['filterParams', 'statisticParams'],
  },
  {
    fieldNames: ['type'],
    prefix: 'FACET_TYPE_',
    recursiveFieldPatterns: ['facets'],
  },
  {
    fieldNames: ['type'],
    prefix: 'FIELD_DEFINITION_TYPE_',
    recursiveFieldPatterns: [
      'facets',
      'field',
      'filterParams',
      'filters',
      'sorts',
      'typeaheadFields',
      'selects',
      'facetPivots',
      'statisticParams',
      'fieldDefinitions',
    ],
  },
  {
    fieldNames: ['orderBy'],
    prefix: 'SORT_ORDER_',
    recursiveFieldPatterns: ['sorts'],
  },
  {
    fieldNames: ['statistic'],
    prefix: 'STATISTIC_TYPE_',
    recursiveFieldPatterns: ['statisticParams'],
  },
];

/**
 * Simplified timestamp field names for portfolio POST requests.
 * Uses recursive traversal to automatically handle all nesting levels.
 * Replaces 80+ JMESPath expressions with 5 simple field names.
 */
export const AGRAPH_PORTFOLIO_POST_TIMESTAMP_FIELDS = [
  'createTime',
  'updateTime',
  'asOf',
  'creationTimestamp',
  'lastUpdatedTimestamp',
];

/**
 * Simplified enum prefix configurations for portfolio POST requests.
 * Uses recursive field patterns to automatically handle all nesting levels.
 * Replaces 80+ JMESPath expressions with 5 simple field name configs.
 */
export const AGRAPH_PORTFOLIO_ENUM_PREFIXES = [
  {
    fieldNames: ['valueType'],
    prefix: 'VALUE_TYPE_',
    recursiveFieldPatterns: [
      'mandateRestrictions',
      'otherBenchmarks',
      'benchmark',
      'otherModels',
      'model',
      'supplement',
      'sleeveInfo',
      'modelRefs',
      'benchmarkPortfolio',
      'modelPortfolio',
      'models',
    ],
  },
  {
    fieldNames: ['origin'],
    prefix: 'ORIGIN_',
    recursiveFieldPatterns: [
      'otherBenchmarks',
      'benchmark',
      'otherModels',
      'model',
      'supplement',
      'sleeveInfo',
      'modelRefs',
      'benchmarkPortfolio',
      'modelPortfolio',
      'models',
      'benchRef',
      'modelRef',
      'benchmarkRef',
    ],
  },
  {
    fieldNames: ['application'],
    prefix: 'APPLICATION_',
    recursiveFieldPatterns: [
      'mandateRestrictions',
      'otherBenchmarks',
      'benchmark',
      'otherModels',
      'model',
      'supplement',
      'sleeveInfo',
      'modelRefs',
      'benchmarkPortfolio',
      'modelPortfolio',
      'models',
    ],
  },
  {
    fieldNames: ['type'],
    prefix: 'RESTRICTION_TYPE_',
    recursiveFieldPatterns: [
      'mandateRestrictions',
      'otherBenchmarks',
      'benchmark',
      'otherModels',
      'model',
      'supplement',
      'sleeveInfo',
      'modelRefs',
      'benchmarkPortfolio',
      'modelPortfolio',
      'models',
    ],
  },
  {
    fieldNames: ['severity'],
    prefix: 'SEVERITY_',
    recursiveFieldPatterns: [
      'mandateRestrictions',
      'otherBenchmarks',
      'benchmark',
      'otherModels',
      'model',
      'supplement',
      'sleeveInfo',
      'modelRefs',
      'benchmarkPortfolio',
      'modelPortfolio',
      'models',
    ],
  },
];
